import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VideoDrawer from '@blade/common/components/task-management/simple-drawer.vue';
import { plotMap, modelTypeData } from './plotConfig';
import { setCustomOptions, setCustomOptionsColor } from '@blade-sxp/task-management/constant/drawer-options';
import MarkMap from '@blade-sxp/task-management/components/deviceDarwer/mark-map.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty } from 'lodash';
import { getQueryLablePerson, getModelType } from '@blade-sxp/task-management/api/creat-task/index';
import MultiBehavior from './multi-behavior.vue';
import colors from '@/styles/color.scss';
import ModelType from '@blade-sxp/task-management/components/deviceDarwer/model-type.vue';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import { HandleDeviceIdTree } from '@blade/common/store/deviceTree';
import BodyAttributeRecognition from '@blade-sxp/task-management/components/deviceDarwer/body-attribute-recognition.vue';
const Service = {
    getQueryLablePerson,
    getModelType,
};
let DarwerPlot = class DarwerPlot extends Vue {
    taskType;
    justWatchVideos;
    styleProp;
    deviceIdList;
    disabled;
    directionConfig = {};
    roi = require('@blade-sxp/task-management/assets/roi.png'); // roi 多边形
    arrow = require('@blade-sxp/task-management/assets/arrow.png'); // arrow
    line = require('@blade-sxp/task-management/assets/line.png'); // line
    straight = require('@blade-sxp/task-management/assets/straight.png'); // line
    bodyFrame = require('@blade-sxp/task-management/assets/bodyframe.png'); // Bodyframe
    complete = require('@blade-sxp/task-management/assets/tick_circle.png');
    downIcon = require('@blade-sxp/task-management/assets/down.png');
    tipInfor = {
        tipImg: this.roi,
        tipType: 'roi',
    };
    timeLineMap = new Map();
    darwerType = 'ROI';
    page = 1;
    drawButtons = ['polygon'];
    limits = {};
    isPlay = true;
    paintState = false;
    options = setCustomOptions('polygon');
    rtspUrl = '';
    showSelect = false;
    dataSource = [];
    localPlotData = [];
    deviceId = '';
    lineTimeData = [];
    noData = 'noRoi';
    roiType = 'ROI';
    isUseDraw = true;
    deleteTip = 'roiDetailTip';
    mouseTip = 'mouseRoiTip';
    hehaviorList = [];
    palying = false;
    activeBackgroundId = '';
    isRoadLength = true;
    noRoadList = [];
    taskTypeConfigure = {
        drawingProcess: null,
        timeline: null,
        incidentType: null,
        multipleRoi: {
            behavior: [],
            quantity: 8,
            status: true,
        },
        notNecessarily: false,
    };
    notNecessarily = false;
    currentBehavior = {
        label: '',
        value: '',
    };
    modelTypeValue = modelTypeData[0]?.value || '';
    // plotDataMap:Map<string, object> = new Map();
    // CROWD_CROSS_LINE_STATISTIC
    isComplete = true;
    deviceRoiValueStateList = [];
    enableAttributesAnalysis = false;
    get isDarwerTypeModel() {
        return this.darwerType === 'MODEL';
    }
    get isEnableAttributes() {
        return this.isDarwerTypeModel && plotMap.get(this.taskType)?.bodyAttributeRecognition;
    }
    get getCrrentRoi() {
        return DeviceIdDataModule.isMapData;
    }
    get isShowBehavior() {
        const { behavior } = this.taskTypeConfigure?.multipleRoi;
        const statusData = behavior;
        this.notNecessarily = this.taskTypeConfigure?.notNecessarily;
        this.hehaviorList = statusData?.map((item) => {
            return {
                label: item.label,
                value: item.value,
            };
        });
        return !isEmpty(statusData);
    }
    get isShowNextBtn() {
        if (this.darwerType === 'MAP') {
            return this.isComplete;
        }
        else if (this.darwerType === 'MODEL') {
            return this.modelTypeValue !== '';
        }
        else {
            return this.localPlotData && this.localPlotData.length > 0;
        }
    }
    get currentRtspUrl() {
        return DeviceIdDataModule.currentRtspUrl;
    }
    get total() {
        return this.lineTimeData?.length;
    }
    get isDetail() {
        return this.$route.query.type !== 'detail';
    }
    get mostDarwerNumber() {
        const { status, quantity } = this.taskTypeConfigure?.multipleRoi;
        if (status) {
            return this.localPlotData?.length === quantity;
        }
        if (this.darwerType === 'BODY') {
            return this.localPlotData?.length === 10;
        }
        else if (this.taskType === 'CROWD_STATISTIC' && this.darwerType === 'ROI') {
            return this.localPlotData?.length === 2;
        }
        else {
            return this.localPlotData?.length === 1;
        }
    }
    get videoPlayerStyle() {
        let style = '';
        if (!this.lineTimeData) {
            style = `width:${Number(this.styleProp.width) / 10}rem;height:${Number(this.styleProp.height) / 10}rem;align-items:center`;
        }
        else {
            style = `width:${Number(this.styleProp.width) / 10}rem;height:${Number(this.styleProp.height) / 10}rem`;
        }
        return style;
    }
    get setLineWidth() {
        let style = '';
        if (this.total === 1) {
            style = `width:0rem`;
        }
        if (this.total > 1 && this.total <= 3) {
            style = `width:28rem`;
        }
        if (this.total === 4) {
            style = `width:15rem`;
        }
        return style;
    }
    getCrrentRoiMap(val) {
        this.isComplete = val;
    }
    onchageModelType(val) {
        if (val) {
            this.setModelIntValue();
        }
    }
    onEnableAttributesAnalysis(val) {
        this.setEnableAttributesAnalysis();
    }
    get graphHoverId() {
        return MapPolygonsModule.graphHoverId;
    }
    getGraphHover(id) {
        this.activeBackgroundId = id;
    }
    onChangeCurrentRtspUrl(val, oldVal) {
        this.palying = false;
        this.isUseDraw = true;
        if (!isEmpty(this.hehaviorList)) {
            this.currentBehavior = this.hehaviorList[0];
        }
        this.rtspUrl = val;
        if (val !== oldVal) {
            this.deviceId = DeviceIdDataModule?.deviceId;
            this.lineTimeData = DeviceIdDataModule?.deviceIdRequestParams?.get(this.deviceId)?.titleList;
            this.page = 1;
            const lintime = plotMap.get(this.taskType).timeline;
            if (!isEmpty(lintime)) {
                const type = lintime[0]?.type;
                this.darwerType = type;
                this.getRoiType(type);
            }
            else {
                this.darwerType = 'ROI';
                this.getRoiType('ROI');
            }
        }
    }
    onChangeTaskType(val) {
        if (val && plotMap) {
            const value = plotMap.get(val);
            if (value) {
                // this.drawingProcess = plotMap.get(val).drawingProcess;
                this.taskTypeConfigure = plotMap.get(val);
                const lintime = plotMap.get(val).timeline;
                this.setTimeLineMap(lintime);
            }
        }
    }
    onChangeDarwerType(val) {
        if (val) {
            this.getRoiType(val);
            if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
                this.noData = 'trafficJamNoRoi';
            }
        }
    }
    onDeviceIdList(list) {
        this.palying = false;
        this.isUseDraw = true;
        if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
            this.deviceRoiValueStateList = this.deviceRoiValueStateList.filter((d) => list.includes(d.id));
        }
    }
    created() {
        this.deviceId = DeviceIdDataModule?.deviceId;
        this.lineTimeData = DeviceIdDataModule?.deviceIdRequestParams?.get(this.deviceId)?.titleList;
    }
    mounted() {
        window.addEventListener('keyup', this.mouseTipStatus);
    }
    beforeDestroy() {
        window.removeEventListener('keyup', this.mouseTipStatus);
    }
    getRoiType(val) {
        switch (val) {
            case 'ROI':
                this.tipInfor = {
                    tipImg: this.roi,
                    tipType: 'roi',
                };
                this.drawButtons = ['polygon'];
                this.options = setCustomOptions('polygon');
                this.isPlay = true;
                this.noData = 'noRoi';
                this.roiType = 'ROI';
                this.dataSource = this.getRoiMapData('ROI');
                this.localPlotData = this.getRoiMapData('ROI');
                this.deleteTip = 'roiDetailTip';
                this.mouseTip = 'mouseRoiTip';
                break;
            case 'BODY':
                this.queryHumanBody();
                this.tipInfor = {
                    tipImg: this.bodyFrame,
                    tipType: 'Bodyframe',
                };
                this.drawButtons = ['rect'];
                this.options = setCustomOptions('rect');
                this.noData = 'noBody';
                this.roiType = 'Frame';
                this.dataSource = this.getRoiMapData('BODY');
                this.localPlotData = this.getRoiMapData('BODY');
                this.deleteTip = 'farmeDetailTip';
                this.mouseTip = 'mouseBodyTip';
                break;
            case 'DIRECTION':
                this.tipInfor = {
                    tipImg: this.arrow,
                    tipType: 'arrow',
                };
                this.drawButtons = ['arrow'];
                this.options = setCustomOptions('arrow');
                this.isPlay = true;
                this.noData = 'noArrow';
                this.roiType = 'Direction';
                this.dataSource = [...this.getRoiMapData('ROI'), ...this.getRoiMapData('DIRECTION')];
                this.localPlotData = this.getRoiMapData('DIRECTION');
                this.deleteTip = 'arrowDetailTip';
                this.mouseTip = 'mouseArrowTip';
                break;
            case 'LINES':
                if (this.taskType === 'CROSS_LINE_ALERT_DETECT') {
                    this.drawButtons = ['line'];
                    this.tipInfor = {
                        tipImg: this.straight,
                        tipType: 'lines',
                    };
                    this.directionConfig = { unknown: 3 };
                    // this.drawButtons = ['line'];
                }
                else {
                    this.tipInfor = {
                        tipImg: this.line,
                        tipType: 'lines',
                    };
                    // this.directionConfig = {};
                    this.drawButtons = ['lines'];
                }
                this.options = setCustomOptions('line');
                // this.isPlay = true;
                this.noData = 'noLine';
                this.roiType = 'Crossline';
                this.dataSource = this.getRoiMapData('LINES');
                this.localPlotData = this.getRoiMapData('LINES');
                this.deleteTip = 'linesDetailTip';
                this.mouseTip = 'mouseLinesTip';
                break;
            case 'MODEL':
                this.getModelValue('MODEL');
                this.paintState = false;
                this.dataSource = [];
                this.localPlotData = [];
                break;
            default:
                this.isPlay = true;
                this.tipInfor = {
                    tipImg: this.roi,
                    tipType: 'roi',
                };
                this.noData = 'noRoi';
                this.roiType = 'ROI';
                this.drawButtons = ['polygon'];
                this.options = setCustomOptions('polygon');
                this.deleteTip = 'roiDetailTip';
        }
    }
    changeItemInput() {
        this.formatDarwerData(this.localPlotData);
        if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
            this.changeCheckRoadLength(this.localPlotData);
        }
    }
    roiAreaHover(id) {
        if (id === this.activeBackgroundId) {
            return colors.deviceCascaderBg;
        }
        else {
            return colors.white;
        }
    }
    mouseenterGetId(graph) {
        if (this.localPlotData.length === 1)
            return;
        if (graph.type === 'rect' || graph.type === 'polygon') {
            MapPolygonsModule.updataGraphHover(graph.id);
        }
    }
    // 开始绘制
    startDraw() {
        this.paintState = true;
        if (this.darwerType === 'BODY') {
            this.isPlay = false;
        }
    }
    getModelValue(type) {
        const data = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
        if (!isEmpty(data)) {
            const { titleList } = data;
            if (!isEmpty(titleList)) {
                titleList.forEach((item) => {
                    if (item.type === type) {
                        this.modelTypeValue = item.data || modelTypeData[0]?.value;
                        this.enableAttributesAnalysis = item.enableAttributesAnalysis || false;
                    }
                });
            }
        }
    }
    setModelIntValue() {
        const data = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
        if (!isEmpty(data)) {
            const { titleList } = data;
            if (!isEmpty(titleList)) {
                titleList.forEach((item) => {
                    if (item.type === 'MODEL') {
                        item.data = this.modelTypeValue;
                    }
                });
            }
        }
        const allIsComplete = data?.titleList.every((item) => item.isComplete === true);
        data.isComplete = allIsComplete;
        DeviceIdDataModule?.deviceIdRequestParams.set(this.deviceId, data);
    }
    setEnableAttributesAnalysis() {
        const data = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
        if (data) {
            const { titleList = [] } = data || {};
            titleList.forEach((item) => {
                if (item.type === 'MODEL') {
                    item.enableAttributesAnalysis = this.enableAttributesAnalysis;
                }
            });
        }
        const allIsComplete = data?.titleList.every((item) => item.isComplete === true);
        data.isComplete = allIsComplete;
        DeviceIdDataModule?.deviceIdRequestParams.set(this.deviceId, data);
    }
    setBagColor(color) {
        const { fillStyle } = color?.options?.normal;
        return `backgroundColor:${fillStyle}`;
    }
    getCommand(command) {
        this.currentBehavior = command;
        const status = this.setDropdownStatus(this.currentBehavior?.value);
        if (status) {
            this.paintState = false;
            this.$message.error(`${this.$t('mostTask')}`);
        }
        else {
            const { behavior } = this.taskTypeConfigure?.multipleRoi;
            if (!isEmpty(behavior)) {
                behavior.forEach((item) => {
                    const { fillColors, strokeColor } = item?.roiColor;
                    if (item.value === command.value) {
                        this.options = setCustomOptionsColor('polygon', fillColors, strokeColor);
                    }
                });
            }
            this.paintState = true;
        }
    }
    setMapData(data) {
        this.localPlotData = data;
    }
    setTimeLineMap(val) {
        this.timeLineMap.clear();
        if (val) {
            val.forEach((item) => {
                this.timeLineMap.set(item.index, item.text);
            });
        }
    }
    getDrawend(val) {
        if (!isEmpty(val)) {
            let data = [];
            val.forEach((item) => {
                if (this.darwerType === 'ROI' && item.type === 'polygon') {
                    if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
                        let dataItem = {
                            length: '',
                            ...item,
                        };
                        this.localPlotData.forEach((localPlotDataItem) => {
                            if (item.id === localPlotDataItem.id && localPlotDataItem.length) {
                                dataItem.length = localPlotDataItem.length;
                            }
                        });
                        data.push(dataItem);
                    }
                    else {
                        data.push(item);
                    }
                }
                if (this.darwerType === 'DIRECTION' && item.type === 'arrow') {
                    data.push(item);
                }
                if (this.darwerType === 'BODY' && item.type === 'rect') {
                    data.push(item);
                }
                if (this.darwerType === 'LINES' && item.type === 'lines') {
                    data.push(item);
                }
                if (this.darwerType === 'LINES' && item.type === 'line') {
                    data.push(item);
                }
            });
            data.forEach((d) => { });
            this.localPlotData = data;
            if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
                this.checkRoadLength(this.localPlotData);
            }
            const size = DeviceIdDataModule.markMapData && DeviceIdDataModule.markMapData.size;
            if (this.darwerType === 'ROI' && size > 0) {
                DeviceIdDataModule.markMapData.clear();
            }
        }
        else {
            this.localPlotData = [];
        }
        // console.log('修改名字', this.localPlotData);
        // DeviceIdDataModule.updataRoi(val);
        this.formatDarwerData(this.localPlotData);
        this.paintState = false;
        this.isPlay = true;
    }
    formatDarwerData(val) {
        if (this.darwerType && this.darwerType.length > 0) {
            this.setDeviceIdMap(this.darwerType, val);
        }
    }
    setDeviceIdMap(type, val) {
        const data = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
        if (!isEmpty(data)) {
            data?.titleList.forEach((item) => {
                if (item.type === type) {
                    item.data = val;
                    if (!isEmpty(val)) {
                        if (type === 'BODY') {
                            const len = val?.length;
                            if (len >= 3) {
                                item.isComplete = true;
                            }
                            else {
                                item.isComplete = false;
                            }
                        }
                        else {
                            item.isComplete = true;
                        }
                        if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
                            const allItemIsComplete = val.every((item) => item.isComplete === true);
                            item.isComplete = allItemIsComplete;
                        }
                    }
                    else {
                        item.isComplete = false;
                    }
                }
            });
            const allIsComplete = data?.titleList.every((item) => item.isComplete === true);
            data.isComplete = allIsComplete;
            DeviceIdDataModule?.deviceIdRequestParams.set(this.deviceId, data);
            DeviceIdDataModule.updataMonitoringIndex();
        }
    }
    getRoiMapData(type) {
        const data = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
        let roiData = [];
        if (!isEmpty(data)) {
            data?.titleList?.forEach((item) => {
                if (item.type === type) {
                    roiData = item.data;
                }
            });
        }
        if (this.taskType === 'TRAFFIC_CONGESTION_DETECT') {
            this.checkRoadLength(roiData);
        }
        return roiData;
    }
    deleteRoi(id) {
        let tip = '';
        if (this.darwerType === 'ROI') {
            tip = 'roiTip';
        }
        if (this.darwerType === 'BODY') {
            tip = 'bodyframes';
        }
        if (this.darwerType === 'DIRECTION') {
            tip = 'directionDeTip';
        }
        if (this.darwerType === 'LINES') {
            tip = 'linesTip';
        }
        this.$confirm(`${this.$t(tip)}`, `${this.$t('tip')}`, {
            confirmButtonText: `${this.$t('confirm')}`,
            cancelButtonText: `${this.$t('cancel')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            type: 'warning',
        })
            .then(() => {
            let dom = this.$refs.drawerPlot.$refs.simpleDrawer;
            if (dom) {
                dom.deleteGraph(id);
                const isHave = DeviceIdDataModule.markMapData.has(id);
                if (isHave) {
                    DeviceIdDataModule.markMapData.delete(id);
                }
                if (this.darwerType === 'ROI') {
                    // DeviceIdDataModule?.updataMapData(false);
                    DeviceIdDataModule?.updataIsMapData(false);
                    DeviceIdDataModule.markMapData.clear();
                }
            }
            dom = null;
        })
            .catch(() => { });
    }
    nextBtn() {
        if (this.darwerType === 'MODEL') {
            const routeParam = this.$route.query;
            let params = {
                deviceId: Number(this.deviceId),
                modelType: this.modelTypeValue,
                taskType: routeParam?.taskType,
            };
            if (routeParam?.id && routeParam?.type && routeParam?.type !== 'add') {
                const taskId = Number(routeParam?.id);
                params.taskId = taskId;
            }
            const deviceName = HandleDeviceIdTree.deviceIdMap.get(this.deviceId);
            Service.getModelType(params).then((res) => {
                if (res && res?.length > 0) {
                    this.$confirm(`${this.$t('modelTip', { deviceName: deviceName })}`, `${this.$t('tip')}`, {
                        confirmButtonText: `${this.$t('confirm')}`,
                        cancelButtonText: `${this.$t('cancel')}`,
                        cancelButtonClass: 'cancel-roi-tip',
                        confirmButtonClass: 'confirm-roi-tip',
                        customClass: 'task-confirm',
                    })
                        .then(() => {
                        this.page++;
                        this.setDarwerType();
                    })
                        .catch(() => { });
                }
                else {
                    this.page++;
                    this.setDarwerType();
                }
            });
        }
        else {
            this.page++;
            this.setDarwerType();
        }
    }
    previousBtn() {
        this.page--;
        this.setDarwerType();
    }
    setDarwerType() {
        if (this.lineTimeData && this.page) {
            this.lineTimeData.forEach((item) => {
                if (this.page === item.index) {
                    this.darwerType = item.type;
                }
            });
            this.localPlotData = [];
            this.dataSource = [];
            this.clearPlot();
        }
    }
    clearPlot() {
        let dom = this.$refs.drawerPlot.$refs.simpleDrawer;
        if (dom) {
            dom.handleClear();
        }
        dom = null;
    }
    getPlaybackStatus(val) {
        this.isUseDraw = false;
        this.palying = val;
    }
    queryHumanBody() {
        Service.getQueryLablePerson([this.deviceId]).then((res) => {
            if (!isEmpty(res)) {
                const roidata = res[this.deviceId].roiData;
                if (!isEmpty(roidata)) {
                    const pension = JSON.parse(roidata);
                    pension?.titleList?.forEach((item) => {
                        if (item.type === 'BODY') {
                            this.localPlotData = item.data;
                            this.dataSource = item.data;
                            const isCompleted = item.isComplete;
                            const data = DeviceIdDataModule?.deviceIdRequestParams?.get(this.deviceId);
                            if (!isEmpty(data)) {
                                data?.titleList.forEach((el) => {
                                    if (el.type === 'BODY') {
                                        el.data = this.dataSource;
                                        el.isComplete = isCompleted;
                                    }
                                });
                                const allIsComplete = data?.titleList.every((item) => item.isComplete === true);
                                data.isComplete = allIsComplete;
                                DeviceIdDataModule?.deviceIdRequestParams?.set(this.deviceId, data);
                                DeviceIdDataModule.updataMonitoringIndex();
                            }
                        }
                    });
                }
            }
        });
    }
    mouseTipStatus(e) {
        if (!isEmpty(e) && e.key === 'Escape') {
            this.paintState = false;
            const dom = this.$refs.drawerPlot.$refs.simpleDrawer;
            if (!isEmpty(dom)) {
                const point = dom.$refs.paint;
                point.clickEsc(e);
            }
        }
    }
    setDropdownStatus(value) {
        let status = false;
        let data = [];
        if (value === 'kitchenBehaviorDetectConfig') {
            this.localPlotData.forEach((item) => {
                if (item.options?.normal?.fillStyle === colors.polygonStrokeStyle) {
                    data.push(item);
                }
            });
        }
        if (value === 'tableDetectConfig') {
            this.localPlotData.forEach((item) => {
                if (item.options?.normal?.fillStyle === colors.lineFillStyle) {
                    data.push(item);
                }
            });
        }
        if (value === 'kitchenWareDetectConfig') {
            this.localPlotData.forEach((item) => {
                if (item.options?.normal?.fillStyle === colors.boardLevelMajorColor) {
                    data.push(item);
                }
            });
        }
        if (value === 'pestDetectConfig') {
            this.localPlotData.forEach((item) => {
                if (item.options?.normal?.fillStyle === colors.colorDanger) {
                    data.push(item);
                }
            });
        }
        if (!isEmpty(data)) {
            status = data?.length >= 2;
        }
        else {
            status = false;
        }
        return status;
    }
    noRoadListClass(id) {
        if (this.noRoadList.includes(id)) {
            return 'error';
        }
    }
    changeCheckRoadLength(list) {
        this.checkRoadLength(list);
        this.setDeviceIdMap(this.darwerType, list);
    }
    checkRoadLength(list) {
        this.isRoadLength = true;
        this.noRoadList = [];
        if (isEmpty(list))
            return;
        list?.forEach((d) => {
            if (Number(d.length) < 1 || Number(d.length) > 100 || !d.length) {
                this.isRoadLength = false;
                if (!this.noRoadList.includes(d.id)) {
                    this.noRoadList.push(d.id);
                }
                d.isComplete = false;
            }
            else {
                d.isComplete = true;
            }
        });
    }
    noSelectDirection() {
        if (this.darwerType === 'LINES') {
            this.mouseTip = 'crossLineTips';
        }
    }
};
__decorate([
    Prop({ type: String, default: '' })
], DarwerPlot.prototype, "taskType", void 0);
__decorate([
    Prop({ type: Boolean })
], DarwerPlot.prototype, "justWatchVideos", void 0);
__decorate([
    Prop({ type: Object })
], DarwerPlot.prototype, "styleProp", void 0);
__decorate([
    Prop({ type: Array })
], DarwerPlot.prototype, "deviceIdList", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DarwerPlot.prototype, "disabled", void 0);
__decorate([
    Watch('getCrrentRoi', { deep: true, immediate: true })
], DarwerPlot.prototype, "getCrrentRoiMap", null);
__decorate([
    Watch('modelTypeValue')
], DarwerPlot.prototype, "onchageModelType", null);
__decorate([
    Watch('enableAttributesAnalysis')
], DarwerPlot.prototype, "onEnableAttributesAnalysis", null);
__decorate([
    Watch('graphHoverId', { deep: true })
], DarwerPlot.prototype, "getGraphHover", null);
__decorate([
    Watch('currentRtspUrl', { immediate: true })
], DarwerPlot.prototype, "onChangeCurrentRtspUrl", null);
__decorate([
    Watch('taskType', { immediate: true })
], DarwerPlot.prototype, "onChangeTaskType", null);
__decorate([
    Watch('darwerType', { immediate: true })
], DarwerPlot.prototype, "onChangeDarwerType", null);
__decorate([
    Watch('deviceIdList', { immediate: true })
], DarwerPlot.prototype, "onDeviceIdList", null);
DarwerPlot = __decorate([
    Component({
        name: 'DarwerPlot',
        components: {
            'video-drawer': VideoDrawer,
            'mark-map': MarkMap,
            'multi-behavior': MultiBehavior,
            'model-type': ModelType,
            'body-attribute-recognition': BodyAttributeRecognition,
        },
        i18n: {
            messages: {
                en: {
                    road: 'Road',
                    checkRoadRule: 'Please enter road length',
                    examples: 'Example',
                    roiTip: 'Are you sure to delete this ROI?',
                    bodyframes: 'Are you sure to delete this body frame?',
                    directionDeTip: 'Are you sure to delete this direction?',
                    tip: 'Tips',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    noRoi: 'please add ROI area',
                    notNecessarily: 'ROI is not necessarily drawn',
                    noBody: 'please add at least 3 body frames',
                    noArrow: 'please draw a direction',
                    noLine: 'please draw a line',
                    roiDetailTip: 'Please delete the existing ROI area before add a new one',
                    farmeDetailTip: 'Please delete the existing frame before add a new one',
                    arrowDetailTip: 'Please delete the existing Direction before add a new one',
                    linesDetailTip: 'Please delete the existing cross line before add a new one',
                    mouseRoiTip: 'click left button to set points and link them to draw ROI area, click right button or press Esc to cancel',
                    mouseBodyTip: 'hold down left button and drag to draw a rectangle to mark human body, click the right button or press Esc to cancel',
                    mouseArrowTip: 'click and pull left button to draw a line with arrow to define detection, click right or press Esc to cancel',
                    linesTip: 'Are you sure to delete this crossover?',
                    mouseLinesTip: 'click left to put pin on map，click right or Esc to cancel',
                    mostTask: 'At most two ROIs can be drawn for the same subtask',
                    modelTip: 'The model type used by {deviceName} in other tasks does not match the one submitted this time, which may affect the statistical accuracy of other tasks. Are you sure to submit?',
                    trafficJamNoRoi: 'please add ROI area and enter the road length',
                },
                zh: {
                    road: '车道长度',
                    checkRoadRule: '请输入道路长度',
                    examples: '示例',
                    roiTip: '确认删除该ROI吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    noRoi: '请添加ROI区域',
                    notNecessarily: 'ROI不一定绘制出来',
                    noArrow: '请绘制一个方向',
                    noLine: '请绘制一条线',
                    noBody: '请添加至少3个人体标定',
                    bodyframes: '确认删除该人体标定?',
                    directionDeTip: '确认删除该方向吗?',
                    mouseRoiTip: '单击左键设置点并将其链接到绘制ROI区域，单击右键或按Esc取消',
                    mouseBodyTip: '按住左键并拖动以绘制一个矩形来标记人体，单击右键或按Esc键取消',
                    mouseArrowTip: '单击并向左拉按钮以用箭头绘制一条线来定义检测，单击向右或按Esc键取消',
                    mouseLinesTip: '按住左键并拖动以绘制一条跨线，单击右键或按Esc键取消',
                    linesTip: '确认删除该跨线吗？',
                    mostTask: '同一个子任务最多绘制两个ROI',
                    modelTip: '{deviceName} 在其他任务中使用的模型类型与本次提交的不符，提交可能会影响其他项目统计精度，确认提交吗？',
                    trafficJamNoRoi: '请添加ROI区域并输入道路长度',
                },
            },
        },
    })
], DarwerPlot);
export default DarwerPlot;
